import {
  ViewsEnum,
  useFilterContext,
} from "@pages/Dashboard/contexts/Filter.context";
import GanttView from "./Gantt/Gantt.view";
import GridView from "./Grid/Grid.view";

import { useMemo } from "react";
import Sidebar from "../Sidebar/Sidebar.fragment";
import styles from "./Content.module.scss";

const Content: React.FC = () => {
  const { view } = useFilterContext();

  const ganttClass = view !== ViewsEnum.grid ? styles["content-gantt"] : "";

  const className = `${styles.content} ${ganttClass}`.trim();

  const renderView = useMemo(() => {
    switch (view) {
      case ViewsEnum.grid:
        return (
          <>
            <Sidebar />
            <GridView show />
          </>
        );
      case ViewsEnum.gantt:
      case ViewsEnum.detalhada:
        return <GanttView show />;
      default:
        return null;
    }
  }, [view]);

  return <main className={className}>{renderView}</main>;
};

export default Content;
